import { convertProductSetDetailsToListItem } from "modules/productSets";

import { FeedInsertFormValues } from "../components";
import { FeedInsertWidth, FeedInsertType } from "../constants";
import { FeedInsertsListItem } from "../content.types";

export const getInitialFeedInsertFormValues = (
  editableInsert?: FeedInsertsListItem | null
): FeedInsertFormValues => ({
  id: editableInsert?.id,
  name: editableInsert?.name ?? "",
  form: editableInsert?.form ?? FeedInsertWidth.FullWidth,
  type: editableInsert?.type ?? FeedInsertType.SingleMedia,
  header: editableInsert?.header ?? "",
  text: editableInsert?.text ?? "",
  headerBackgroundMedia: editableInsert?.headerBackgroundMedia ?? null,
  backgroundMedia: editableInsert?.backgroundMedia ?? null,
  spaceBeforeSliderStart: editableInsert?.spaceBeforeSliderStart ?? null,

  media:
    editableInsert?.media.map(({ id: _id, ...media }) => ({
      media: media.media,
      productVariants: media.redirection?.productVariants ?? [],
      productSet: convertProductSetDetailsToListItem(
        media.redirection?.productSet
      ),
      allowDisplayInFullScreenMode: media.allowDisplayInFullScreenMode ?? true
    })) ?? [],
  products: editableInsert?.metadata?.productVariants ?? [],
  productSet: convertProductSetDetailsToListItem(
    editableInsert?.metadata?.productSet
  )
});
